import { GetterTree, MutationTree, ActionTree, ActionContext, Module } from "vuex";
import { ref } from "vue";

export class State {
    count?: number;
    searchDrawerMobile?: boolean;
    currentMarkerID_Circle?: number;
    banKinh?: number;
    isMobile?: boolean;
    activeTab_Mobile?: string;
    isSupport_dvh?: boolean;
    innerHeight?: number;
    isFullScreen?: boolean;
    scrollToMap?: boolean;
}
const state: State = {
    count: 10,
    searchDrawerMobile: false,
    currentMarkerID_Circle: -1,
    banKinh: -1,
    isMobile: true,
    activeTab_Mobile: ref('DuAnKeuGoiDauTu').value,
    isSupport_dvh: true,
    innerHeight: 0,
    isFullScreen: false,
    scrollToMap: false,
};

const getters = <GetterTree<State, any>>{
    getStatusSearchDrawerMobile(state: State): boolean {
        return state.searchDrawerMobile || false;
    },
    getCurrentMarkerID_Circle(state: State): number {
        return state.currentMarkerID_Circle || -1;
    },
    getbanKinh(state: State): number {
        return state.banKinh || -1;
    },
    getIsMobile(state: State) {
        return state.isMobile;
    },
    getActiveTab_Mobile(state: State) {
        return state.activeTab_Mobile;
    },
    getIsSupport_dvh(state: State) {
        return state.isSupport_dvh;
    },
    getInnerHeight(state: State) {
        return state.innerHeight;
    },
    getIsFullScreen(state: State) {
        return state.isFullScreen;
    },
    getScrollToMap(state: State) {
        return state.scrollToMap;
    }
};

const mutations = <MutationTree<State>>{
    openSearchDrawerMobile(state: State) {
        state.searchDrawerMobile = true;
    },
    closeSearchDrawerMobile(state: State) {
        state.searchDrawerMobile = false;
    },
    setCurrentMarkerID_Circle(state: State, value: number) {
        state.currentMarkerID_Circle = value;
    },
    setbanKinh(state: State, value: number) {
        state.banKinh = value;
    },
    setIsMobile(state: State, value: boolean) {
        state.isMobile = value;
    },
    setActiveTab_Mobile(state: State, val: string) {
        state.activeTab_Mobile = ref(val).value;
    },
    setIsSupport_dvh(state: State, val: boolean) {
        state.isSupport_dvh = val;
    },
    setInnerHeight(state: State, val: number) {
        state.innerHeight = val;
    },
    setIsFullScreen(state: State, val: boolean) {
        state.isFullScreen = val;
    },
    setScrollToMap(state: State, val: boolean) {
        state.scrollToMap = val;
    },
};

const actions = <ActionTree<State, any>>{
    openSearchTabMobile(store: ActionContext<State, any>) {
        store.commit("openSearchTabMobile");
    },
    // closeSearchDrawerMobile(store: ActionContext<State, any>) {
    //     store.commit("closeSearchDrawerMobile");
    // },
    
};

export const BanDo: Module<any, any> = {
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
};
